import { render, staticRenderFns } from "./frequently_asked_questions.vue?vue&type=template&id=02c143b8&scoped=true"
import script from "./frequently_asked_questions.vue?vue&type=script&lang=js"
export * from "./frequently_asked_questions.vue?vue&type=script&lang=js"
import style0 from "./frequently_asked_questions.vue?vue&type=style&index=0&id=02c143b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c143b8",
  null
  
)

export default component.exports